import React, { FC, ReactNode } from 'react'
import HostNavbar from '../../navbar/HostNavbar'
import HostFooter from '../../footer/HostFooter'


interface Props{
  children: ReactNode
}

const HostLayout: FC<Props> = ({children}) => {
  return (
    <div>
       <HostNavbar/>
        <div className="page-container">
          {children}
        </div>
        <HostFooter/>
    </div>
  )
}

export default HostLayout
